import { render } from "./BaseNotFound.vue?vue&type=template&id=49091f92&scoped=true"
import script from "./BaseNotFound.vue?vue&type=script&lang=js"
export * from "./BaseNotFound.vue?vue&type=script&lang=js"

import "./BaseNotFound.vue?vue&type=style&index=0&id=49091f92&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49091f92"]])

export default __exports__